import * as React from "react";
import {cx} from "emotion";

import "./inline-zoom-preview-img.scss";

import {cs}                    from "@Common/react/chain-services";
import {UseState}              from "@Common/react/use-state";
import {getELoc}               from "@Common/ui-components/browser/get-e-loc";
import {subtractVector}        from "@Common/ui-components/image-editor/common/subtract-vector";
import {DownwardTransitioning} from "@Common/ui-components/modal-service-3/downward-transitioning";
import {debounce}              from "@Common/utils/debounce";
import {chain}                 from "@Common/utils/fs";

export const InlineZoomPreviewImg = ({className=undefined, ratio=3, src}) => cs(
    ["state", (_, next) => UseState({next})],
    ["suspended", (_, next) => UseState({next})],
    ["value", ({state, suspended}, next) => next(suspended.value ? null : state.value)],
    ["trans", ({value}, next) => DownwardTransitioning({
        value: value,
        compare: (v1, v2) => !!v1 === !!v2,
        next,
    })],
    ({state, value, suspended, trans}) => (
        <div {...{
            className: cx(
                "inline-zoom-preview-img-043", className,
                {
                    active: value,
                },
            ),
            ...(() => {
                const d = chain(
                    (r, loc) => state.onChange({
                        point: subtractVector(
                            loc,
                            r,
                        ),
                        boundingSize: {
                            width : r.width,
                            height: r.height,
                        },
                    }),
                    (_) => value ? _ : debounce(_, 100),
                );

                return {
                    onMouseMove: (e) => {
                        const r = e.target["getBoundingClientRect"]();
                        d(r,getELoc(e));
                    },
                    onMouseLeave: () => {
                        state.onChange(null);
                        d["cancel"]?.();
                        suspended.onChange(false);
                    },
                };
            })(),
            onClick: () => suspended.change(v=>!v),
            style: {
                ...(value||trans.active) && {
                    height: (value ?? trans.toValue ?? trans.fromValue).boundingSize.height,
                },
            },
        }}>
            <img {...{
                src: src,

                style: (() => {
                    const withRatio = (ratio, v) => ({
                        width : v.boundingSize.width  * ratio,
                        height: v.boundingSize.height * ratio,
                        top : (1 - ratio) * v.point.y,
                        left: (1 - ratio) * v.point.x,
                    });

                    return {
                        ...trans.active ? {
                            position: "absolute",
                            transition: ["width", "height", "top", "left"].map((t) => t + " 300ms ease").join(", "),
                            ...withRatio(
                                trans.starting ? (
                                    trans.toValue ? 1 : ratio
                                ) : (
                                    trans.toValue ? ratio : 1
                                ),
                                value ?? trans.toValue ?? trans.fromValue
                            ),
                        } : value && {
                            position: "absolute",
                            ...withRatio(ratio, value),
                        },
                    };
                })(),
            }}/>
        </div>
    ),
);

